import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { X } from 'lucide-react'
import { useNavigationStore } from '@/stores/navigation'
import { ROUTES } from '@/utils/constants'

const MobileNavigation: React.FC = () => {
  const { t } = useTranslation()
  const navigationStore = useNavigationStore()

  const products = [
    { name: t('products.referralcx'), route: ROUTES.PRODUCTS.REFERRAL_CX },
    { name: t('products.schedulingcx'), route: ROUTES.PRODUCTS.SCHEDULING_CX },
    { name: t('products.econsultcx'), route: ROUTES.PRODUCTS.ECONSULT_CX },
    { name: t('products.casecx'), route: ROUTES.PRODUCTS.CASE_CX },
    { name: t('products.consumercx'), route: ROUTES.PRODUCTS.CONSUMER_CX },
    { name: t('products.vaxmanagercx'), route: ROUTES.PRODUCTS.VAX_MANAGER_CX },
    { name: t('products.cellcx'), route: ROUTES.PRODUCTS.CELL_CX },
    { name: t('products.probationcx'), route: ROUTES.PRODUCTS.PROBATION_CX },
  ]

  const mainNavItems = [
    { name: t('navigation.aiInEceptionist'), route: '/ai' },
    { name: t('navigation.whoWeServe'), route: '/who-we-serve' },
    { name: t('navigation.resources'), route: '/whitepapers' },
    { name: t('navigation.about'), route: '/about' },
  ]

  const handleNavClick = () => {
    navigationStore.closeMobileMenu()
  }

  return (
    <div className="h-full flex flex-col bg-white">
      {/* Header */}
      <div className="flex items-center justify-between p-4 border-b border-gray-200">
        <div className="flex items-center space-x-2">
          <img
            src="/Logo/EceptionistLogo.png"
            alt="Eceptionist"
            className="h-8 w-auto"
          />
          <span className="text-xl font-bold text-primary-600">
            EceptionistCX
          </span>
        </div>
        <button
          onClick={() => navigationStore.closeMobileMenu()}
          className="p-2 rounded-md text-gray-700 hover:text-primary-600 hover:bg-gray-50 transition-colors"
        >
          <X className="h-6 w-6" />
        </button>
      </div>

      {/* Navigation Content */}
      <div className="flex-1 overflow-y-auto">
        <nav className="px-4 py-6 space-y-6">
          {/* Platform Section */}
          <div>
            <h3 className="text-sm font-semibold text-gray-900 uppercase tracking-wider mb-3">
              {t('navigation.platform')}
            </h3>
            <div className="space-y-1">
              {products.map((product) => (
                <Link
                  key={product.route}
                  to={product.route}
                  onClick={handleNavClick}
                  className="block px-3 py-2 text-base text-gray-700 hover:text-primary-600 hover:bg-gray-50 rounded-md transition-colors"
                >
                  {product.name}
                </Link>
              ))}
            </div>
          </div>

          {/* Main Navigation */}
          <div>
            <h3 className="text-sm font-semibold text-gray-900 uppercase tracking-wider mb-3">
              {t('common.company')}
            </h3>
            <div className="space-y-1">
              {mainNavItems.map((item) => (
                <Link
                  key={item.route}
                  to={item.route}
                  onClick={handleNavClick}
                  className="block px-3 py-2 text-base text-gray-700 hover:text-primary-600 hover:bg-gray-50 rounded-md transition-colors"
                >
                  {item.name}
                </Link>
              ))}
            </div>
          </div>

          {/* Additional Links */}
          <div>
            <h3 className="text-sm font-semibold text-gray-900 uppercase tracking-wider mb-3">
              {t('common.resources')}
            </h3>
            <div className="space-y-1">
              <Link
                to="/blog"
                onClick={handleNavClick}
                className="block px-3 py-2 text-base text-gray-700 hover:text-primary-600 hover:bg-gray-50 rounded-md transition-colors"
              >
                Blog
              </Link>
              <Link
                to="/news"
                onClick={handleNavClick}
                className="block px-3 py-2 text-base text-gray-700 hover:text-primary-600 hover:bg-gray-50 rounded-md transition-colors"
              >
                News
              </Link>
              <Link
                to="/webinars"
                onClick={handleNavClick}
                className="block px-3 py-2 text-base text-gray-700 hover:text-primary-600 hover:bg-gray-50 rounded-md transition-colors"
              >
                {t('products.webinars')}
              </Link>
            </div>
          </div>
        </nav>
      </div>

      {/* Footer */}
      <div className="border-t border-gray-200 p-4">
        <Link
          to="/#demo"
          onClick={handleNavClick}
          className="w-full flex items-center justify-center px-4 py-3 border border-transparent text-base font-medium rounded-md text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 transition-colors"
        >
          {t('common.bookDemo')}
        </Link>
      </div>
    </div>
  )
}

export default MobileNavigation


